import { Grid } from "@material-ui/core";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import CustomInput from "components/CustomInput";
import { useGetPriceByParametersQuery } from "features/clients/pricingRubricSlice";
import { IconDollar } from "icons";
import LoadPricingStyles from "./LoadPricingStyles";
import { useEffect, useState } from "react";

const LoadRubricPricing = ({ load, legIndex, onChange }) => {
    const classes = LoadPricingStyles();

    let loadData = legIndex >= 0 ? load?.loads[legIndex] : {};

    const clientId = load?.clientId;
    const miles = loadData?.miles;
    const weightClass = loadData?.weightClass;

    let { data: rubricPrice, error: priceError, isLoading: isLoadingPrice } = useGetPriceByParametersQuery({ clientId, miles, assetClass: weightClass },
        { skip: !clientId || !weightClass || !miles || miles === 0 });

    const [price, setPrice] = useState();

    useEffect(() => {
        if (rubricPrice) {
            let priceObject = { cost: rubricPrice?.internalCost?.toFixed(2), charge: rubricPrice?.price?.toFixed(2) };
            setPrice(priceObject);
            onChange(priceObject);
        }
    }, [rubricPrice]);

    return (
    <>
        <Grid container className={classes.formWrapper}> 
            <Grid item xs={12} className={classes.title}>
                    Pricing
            </Grid>
            <Authorize profile={permissionProfiles.LOAD.LOAD_EDIT} >
                <Grid item xs={4} className={classes.field}>
                    <CustomInput
                        id="cost"
                        label="Estimated Cost"
                        value={rubricPrice?.internalCost?.toFixed(2) ?? ""}
                        elementType="input"
                        // onChange={(val) => handleChange("cost", val)}
                        numberOnly
                        icon={<IconDollar />}
                        showEmpty
                        disabled
                    />
                </Grid>
            </Authorize>
            <Grid item xs={4} className={classes.field}>
                <CustomInput
                    id="charge"
                    label="Charge"
                    value={rubricPrice?.price?.toFixed(2) ?? ""}
                    elementType="input"
                    // onChange={(val) => handleChange("charge", val)}
                    numberOnly
                    icon={<IconDollar />}
                    showEmpty
                    disabled
                />
            </Grid>
        </Grid>
    </>
    );
}

export default LoadRubricPricing;
